<template>
	<div class="h-screen pt-6 flex flex-col bg-white">
		<Container class="w-full">
			<PageHeading :title="$t('pages.admin.assets.assets_admin_layout.admin_assets')"/>
		</Container>

		<TabLayout :tabs="tabs"/>

		<div class="flex-1 flex flex-col overflow-hidden">
			<router-view class="flex-1"></router-view>
		</div>

	</div>
</template>

<script>
import TabLayout from "@/Layouts/TabLayout.vue";
import PageHeading from "@/Components/PageHeading.vue";
import Container from "@/Components/Container.vue";

export default {
	name: "AssetsAdminLayout",
	components: {Container, PageHeading, TabLayout},
	data() {
		return {}
	},
	computed: {
		tabs() {
			return [
				{
					label: this.$t('pages.admin.assets.assets_admin_layout.assets'),
					current: this.$route.name === 'admin.assets' || this.$route.name.startsWith('admin.assets.asset'),
					to: {name: 'admin.assets'},
					permission: 'create:assets|update:assets',
				},
        {
          label: this.$t('pages.admin.assets.assets_admin_layout.types'),
          current: this.$route.name === 'admin.assets.types' || this.$route.name.startsWith('admin.assets.types'),
          to: {name: 'admin.assets.types'},
          permission: 'create:asset-types|update:asset-types',
        },
		{
          label: this.$t('pages.admin.assets.assets_admin_layout.transfers'),
          current: this.$route.name === 'admin.assets.transfers' || this.$route.name.startsWith('admin.assets.transfers'),
          to: {name: 'admin.assets.transfers'},
          permission: 'create:asset-transfers|read:asset-transfers',
        },
			].filter(t => t.permission === undefined || this.$auth.hasPermission(t.permission))
		}
	},
}
</script>

<style scoped>

</style>